import { useMediaQuery } from '@mui/material'
import React from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import useStyles from './_styles'
import { useButtonsStyles } from '../../../styles'
import { PageHeaderProps } from './_props'

const PageContentHeader = ({ left, right }: PageHeaderProps) => {
    const classes = useStyles()
    const buttonsClasses = useButtonsStyles()
    const isLarge = useMediaQuery('(min-width:600px)')

    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)

    const handleMenu = (event: any) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <div className={classes.PageContentHeader}>
            <div className={classes.PageContentHeaderLeft}>{left}</div>
            {isLarge ? (
                <div className={classes.PageContentHeaderRight}>{right}</div>
            ) : (
                <div className={classes.PageContentHeaderMenu}>
                    {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
                    <Button color="typography" className={buttonsClasses.ButtonTextBlack} onClick={handleMenu}>
                        <MoreVertRoundedIcon />
                    </Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <div className={classes.PageContentHeaderMenuContent}>{right}</div>
                    </Menu>
                </div>
            )}
        </div>
    )
}

export default PageContentHeader
